/**** 类型分组+阈值报警(EN) ****/
export default {
  // 类型分组
  SPACE_GROUP_TITLE: 'Group Of Space Types',
  ADD_GROUP_NAME_PLACEHOLDER: 'Input Group Name',
  SPACE_GROUP_DELETED_ERROR: 'Can’t Delete This Group',
  SPACE_GROUP_DELETED_ERROR_TIPS: 'Can’t Delete None Empty Group',

  FORM_GROUP_TITLE: 'Group',
  FORM_TYPE_NAME: 'Name',
  FORM_TYPE_PRICE: 'Price',

  SPACE_TYPES: 'Space Types',
  ADD_SPACE_TYPES: 'Add Space Type',
  EDIT_SPACE_TYPES: 'Edit Space Type',
  SPACE_TYPE_NAME: 'Space Type Name',
  SPACE_TYPE_RATE_AMOUNT: 'Space Price',
  SPACE_TYPE_RATE_UNIT: 'Price Unit',
  SPACE_TYPES_DELETED_CONFIRM_TIPS: 'Confirm To Delete This Space Type?',

  SPACE_TYPE_NAME_INPUT_TIP: 'Input Space Type Name',
  SPACE_TYPE_RATE: 'Space Type',
  SPACE_TYPE_RATE_INPUT_TIP: 'Input Space Type',
  SPACE_TYPES_EIDT_CONFIRM_TIPS: 'Confirm To Modify This Space Type?',

  FORM_INFPUT_ERROR: 'Invalid Input',
  BATCHES_DELETEL: 'Batch Delete',
  ADD_SIBLING: 'Add Sibling Node',
  ADD_CHILDREN: 'Add Sub Node',
  ITEM_RENAME: 'Rename',
  TYPE_UNIT_HOUR: '¥/Hour',
  TYPE_UNIT_DAY: '¥/Day',
  TYPE_UNIT_MONTH: '¥/Month',
  PECUNIARY_UNIT: 'RMB',
  MIDDLE_TIP: 'Over',

  // 工位设置部分
  HOT_DESK_SETTING_TYPE_RATE: 'Set Space Type For HotDesk',
  DESK_TYPE_RATE_CONFIRM_TIP: 'Confirm To Modify This Space Type?',
  DESK_TYPE_RATE_CONFIRM_MULTIPLE_TIP: 'Confirm To Modify These Space Types?',
  FIXED_DESK_TYPE_CHANGE_CONFIRM_TIP: 'Confirm To Modify This Space Type?',
  HOT_DESK_TYPE_CHANGE_CONFIRM_TIP: 'Confirm To Modify This Space Type?',
  // 实时概览
  BOOKING_OVERVIEW_TITLE: 'Desk Overview',
  OVERVIEW_DESK_USER: 'Occupy Users',
  OVERVIEW_DESK_AREA: 'Total Area',
  OVERVIEW_AVERAGE_DESK_AREA: 'Average Area',
  OVERVIEW_DESK_USAGE_RATE: 'Utilization Ratio',
  OVERVIEW_DESK_TOTAL_NUM: 'Total Desks',
  OVERVIEW_DESK_FREE_NUM: 'Available Desks',
  OVERVIEW_FIXED_DESK_BOOKING_USAGE: 'Assignments Of Fixed Desks',
  OVERVIEW_FIXED_DESK_COUNT: 'Total Fixed Desks',
  OVERVIEW_HOT_DESK_BOOKING_USAGE: 'Usage Of Hot Desks',
  OVERVIEW_HOT_DESK_COUNT: 'Total Hot Desks',
  FIXED_DESK_TYPE_VACANCY: 'Unassigned(Available)',
  FIXED_DESK_TYPE_BIND: 'Bonded(In Use)',
  FIXED_DESK_TYPE_ALLOT: 'Assigned',
  HOT_DESK_TYPE_VACANCY: 'Bookable(Available)',
  HOT_DESK_TYPE_BUSY: 'Signed In(In Use)',
  HOT_DESK_TYPE_BOOKING: 'Booked',
  OVERVIEW_FIXED_USAGE_RATE_TIPS: 'Bonded Fixed Desks/Total Fixed Desks',
  OVERVIEW_FIXED_UNUSE_RATE_TIPS: 'Unassigned Fixed Desks/Total Fixed Desks',
  OVERVIEW_HOT_USAGE_RATE_TIPS: 'Signed In Hot Desks/Total Hot Desks',
  OVERVIEW_HOT_UNUSE_RATE_TIPS: 'Bookable Hot Desks/Total Hot Desks',
  OVERVIEW_DEPARTMENT_USE_RATE_TIPS: 'Dept Used Desks/Total Desks Of This Dept',
  // 预定报表
  BOOKING_FORM_TYPES_RATE_INFO: 'Space Types',
  BOOKING_FORM_SPACE_TYPES_RATE: 'Space Type',
  BOOKING_FORM_SPACE_TYPES_RATE_TIP: 'Space Type At Begin Time',
  BOOKING_FORM_USAGE_COST: 'Space Cost',
  BOOKING_FORM_USAGE_COST_TIP:
    // eslint-disable-next-line max-len
    'Space Cost=(Space Price)*(Total Occuppied Time)(Which Is Actual_End_Time - Actual_Begin_Time, Less Than Half An Hour Will Be Counted As 30mins)',
  // 阈值报警
  ALARM_VALUE_SETTING: 'Threshold Settings',
  ALARM_DEPARTMENT_LIST: 'Threshold Of Departments',
  ALARM_BUILDING_LIST: 'Threshold Of Buildings',
  ALARM_VALUE_USAGE_RANGE: 'Monitoring Target',
  ALARM_VALUE_TRIGGERS: 'Condition',
  ALARM_VALUE_RULE_NAME: 'Notification Type',
  ALARM_VALUE_USAGE_RANGE_PLACEHOLDER: 'Monitoring Target Is Required',
  ALARM_VALUE_TRIGGERS_PLACEHOLDER: 'Alarm Condition Is Required',
  ALARM_VALUE_RULE_NAME_PLACEHOLDER: 'Rule Is Required',
  ALARM_VALUE_TRIGGERS_VALUE_TIPS: 'Percentage Is Required',
  ADD_TRIGGER: 'Add Threshold Alarm Trigger',

  ADD_DEPARTMENT_ALARM: 'Add Threshold Of Department',
  EDIT_DEPARTMENT_ALARM: 'Edit Threshold Of Department',
  DELETED_DEPARTMENT_ALARM_TIPS: 'This Will Delete All Threshold Settings Of This Department, Confirm To Continue?',
  ADD_BUILDING_ALARM: 'Add Threshold Of Builing',
  EDIT_BUILDING_ALARM: 'Edit Threshold Of Builing',
  DELETED_BUILDING_ALARM_TIPS:
    'This Will Delete All Threshold Settings Of This Location(Building), Confirm To Continue?',

  ALARM_NOTIFY_SETTING: 'Threshold Notification Setting',
  ADD_ALARM_NOTIFY_RULE: 'Add Notification Rule',
  DELETED_ALARM_NOTIFY_RULE: 'Confirm To Delete【{name}】?',
  DELETED_ALARM_NOTIFY_RULE_TIPS:
    'All Settings Under This Notification Settings Should Be Switched To【{name}】, After Current Setting Is Deleted',
  EDIT_ALARM_NOTIFY_RULE: 'Add Notification Rule',
  ALARM_NOTIFY_RULE: 'Custom Notification Rule',
  ALARM_NOTIFY_RULE_NAME_PLACEHOLDER: 'Input Rule Name',
  ALARM_NOTIFY_RULE_NAME_TIPS: '*Note：Added Notification Receivers Will Only Be Notified From Now On',
  ALARM_NOTIFY_RULE_FREQUENCY: 'Notify Frequency',
  ALARM_NOTIFY_RULE_ROLES_FORM: 'Send To',
  ALARM_NOTIFY_RULE_ROLES: 'Send By',
  ALARM_NOTIFY_RULE_CONTENT: 'Content',
  ALARM_NOTIFY_RULE_CONTENT_PLACEHOLDER: 'Content Is Required',
  ALARM_NOTIFY_FREQUENCY_TEXT: 'Notify Only Once',
  ALARM_FIXED_DESK_USAGE_RATE: 'Usage Ratio Of Fixed Desks',
  ALARM_FIXED_DESK_USAGE_RATE_OVER: 'When Usage Ratio Exceeds ',
  ALARM_FIXED_DESK_VACANT_RATE: 'Available Ratio Of Fixed Desks',
  ALARM_FIXED_DESK_VACANT_RATE_OVER: 'When Available Ratio Exceeds ',
  ALARM_HOT_DESK_USAGE_RATE: 'Usage Ratio Of Hot Desks',
  ALARM_HOT_DESK_USAGE_RATE_OVER: 'When Usage Ratio Exceeds ',
  HANDLE_CURRENT_NOTIFY: 'Notification',
  HANDLE: 'Edit',
  HANDLE_SUCCESS: 'Success',
  NOTIFY_HANDLER: 'Operator',
  NOTIFY_HANDLE_TIME: 'Update Time',
  NOTIFY_TIME: 'Notification Time',
  NOTIFY_ALARM_TRIGGER_VAL: 'Current Value',
  NOTIFY_USAGE_RANGE: 'Monitored Target',
  NOTIFY_TYPE: 'Threshold Type',
  NOTIFY_HANDLER_PLACEHOLDER: 'Operator Is Required',
  NOTIFY_HANDLER_INPUT_ERROR: 'Less Than 10 Operators Are Allowed Here',
  ALARM_NOTIFY_DETAIL: 'Notification Detail',
  HANDLE_DETAIL: 'Notification Process Log',
  LIST_SEARCH_PLACEHOLDER: 'Keyword: Monitored Dept. Name Or Location Name',

  NOTIFY_FOR_BUILDINGS: 'Notificaitons For Buildings',
  NOTIFY_FOR_DEPARTMENTS: 'Notifications For Departments',
}
